export const bannerTypes = {
  HEADER_TYPE_HOMEPAGE: 'homepage',
  HEADER_TYPE_SM: 'sm',
  HEADER_TYPE_MD: 'md',
  HEADER_TYPE_XL: 'xl',
}
